
import { defineComponent, computed } from "vue";
import Modal from "../Components/Modal.vue";
import { useStore } from "../../stores";
import { Assets } from "../../game/resources";
import { IAssetsConfig } from "../../types/game-config-type";
import { GameConfig } from "../../config/game-config";
import { WagerTypeEnum } from "../../types/wager-type-enum";
import gameApplication from "../../game/game-app";
import { GameTypeEnum } from "@/types/game-type-enum";

const sounds: IAssetsConfig = GameConfig.sounds;

export default defineComponent({
  name: 'InvitationRequestModal',

  data() {
    return {
      elapsedTime: 30,
      timer: undefined, 
    };
  },

  setup() {
    Assets.playSound(sounds.paths.INVITATION_DIALOG, 1);
    const store = useStore();
    const newGame = computed(() => store.state.inviteGame);
    const modalText = computed(() => store.state.inviteText);
    return { newGame, modalText };
  },

  mounted() {
    this.startTimer();
  },

  methods: {
    startTimer(): void {
      const timeLimit = 30;
      let startTime = Date.now();
      let elapsedTime = startTime;
      this.timer = setInterval(() => this.modalTimer(elapsedTime, startTime, timeLimit), 1000); // this should be a 1 second interval 
    },

    modalTimer(elapsedTime: number, startTime: number, timeLimit: number): void {
      elapsedTime = Date.now() - startTime;
      let seconds = Math.round((elapsedTime / 1000));
      this.elapsedTime = timeLimit - seconds;

      if (this.elapsedTime == 0) {
        clearInterval(this.timer);
      }
    },

    onAccept(): void {
      if (GameTypeEnum[GameTypeEnum[this.newGame.gameType]] === GameTypeEnum.Wager 
            && gameApplication.wagerMode === WagerTypeEnum.Wallet) {
        gameApplication.acceptWagerGame(this.newGame.player1, this.newGame.wager, this.newGame.network);
      } else {
        gameApplication.sendAcceptGame(true);
      }
      clearInterval(this.timer);
      this.$emit('close');
    },

    onDecline(): void {
      clearInterval(this.timer);
      this.$emit('close');
      gameApplication.sendAcceptGame(false);
      gameApplication.initRoom(); // stop the confirmation modal from being displayed
    },

    getGameType(gameType: string): string {
      switch (gameType) {
        case '0':
          return 'Friendly';
        case '1':
          return 'Wager';
        case '2':
          return 'Ranking';  
        case '4':
          return 'League';
        default:
          return 'Unknown';
      }
    },

    getNetwork(network: string): string {
      switch (network) {
        case 'AVAX':
          return 'Avalanche';  
        case 'BNB':
          return 'Binance Smart Chain';
        case 'FTM':
          return 'Fantom';
        case 'MATIC':
          return 'Polygon';
        case 'ETH':
          return 'Ethereum';            
        default:
          return 'Unknown';
      }
    },
  },

  components: { Modal },
});
